import { render, staticRenderFns } from "./tableExpand.vue?vue&type=template&id=616d1257&"
import script from "./tableExpand.vue?vue&type=script&lang=js&"
export * from "./tableExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports